import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'core-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class NotFoundComponent implements OnInit {

  public errorSize: string = 'large';

  ngOnInit() {
    this.onResize();
  }

  onResize() {
    if (window.innerWidth < 1100) {
      this.errorSize = 'small';
    }
    else if (window.innerWidth < 1450) {
      this.errorSize = 'medium';
    } else {
      this.errorSize = 'large';
    }
  };

}
